import React, { useState, useEffect } from 'react';
import './styles/App.css';
import './styles/LoginForm.css';
import WorkoutPlayer from './components/WorkoutPlayer';
import LoginForm from './components/LoginForm';
import { workoutPrograms } from './data/workoutProgram';
import { api } from './services/api';

function App() {
  const [currentWorkoutIndex, setCurrentWorkoutIndex] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  // Check authentication and determine next workout on load
  useEffect(() => {
    const initializeApp = async () => {
      if (api.isAuthenticated()) {
        try {
          // Fetch recent workouts to determine the next workout in rotation
          const workouts = await api.getWorkouts();
          setIsAuthenticated(true);
          
          // Determine the next workout index based on most recent workout
          if (workouts && workouts.length > 0) {
            const lastWorkout = workouts[0]; // Most recent workout (sorted by timestamp)
            const lastWorkoutName = lastWorkout.workoutName;
            
            // Find index of the last workout in the workout program array
            const lastWorkoutIndex = workoutPrograms.findIndex(w => w.name === lastWorkoutName);
            
            if (lastWorkoutIndex !== -1) {
              // Set the next workout in the rotation
              const nextWorkoutIndex = (lastWorkoutIndex + 1) % workoutPrograms.length;
              setCurrentWorkoutIndex(nextWorkoutIndex);
            }
          }
          // If no workouts found or error, default to first workout (index 0)
        } catch (error) {
          // If there's an error, the token might be invalid
          console.error('Error initializing app:', error);
          api.logout();
        }
      }
      setIsLoading(false);
    };
    
    initializeApp();
  }, []);
  
  const handleWorkoutComplete = () => {
    // Move to next workout, cycling back to the first one after the last
    setCurrentWorkoutIndex((prevIndex) => (prevIndex + 1) % workoutPrograms.length);
  };
  
  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };
  
  const handleLogout = () => {
    api.logout();
    setIsAuthenticated(false);
  };
  
  if (isLoading) {
    return <div className="loading-screen">Loading...</div>;
  }
  
  if (!isAuthenticated) {
    return <LoginForm onLoginSuccess={handleLoginSuccess} />;
  }
  
  return (
    <div className="App">
      <div className="main-container">
        <main>
          <WorkoutPlayer 
            workout={workoutPrograms[currentWorkoutIndex]} 
            onWorkoutComplete={handleWorkoutComplete}
          />
        </main>
        <button onClick={handleLogout} className="logout-button">Logout</button>
      </div>
    </div>
  );
}

export default App;